import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';
import { StyleHelper } from '@xanadu/common';
import { InputComponent } from '../input/input.component';
import { JsonValidator } from '../validator/json-validator';

@Component({
    selector: 'app-json',
    templateUrl: './json.component.html',
    styleUrls: ['./json.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JsonComponent extends InputComponent {
    public textStyle?: SafeStyle;
    public update = output<string>();

    constructor(
        private readonly styleHelper: StyleHelper
    ) {
        super();

        const meta = this.meta();

        if (meta?.textStyle) {
            this.textStyle = this.styleHelper.parse(meta.textStyle);
        }
    }

    onChange(event: any) {
        this.update.emit(event.target.value);
    }

    protected getValidators(): any[] {
        const validators = super.getValidators();
        validators.push(JsonValidator());

        return validators;
    }
}
